import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const Container = styled.div`
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.1);
  border: 1px solid ${theme.colors.gray300};
  border-radius: ${theme.border.mediumRadius};
  width: 100%;
  position: relative;
  transition: border-color 0.2s ease-in-out;

  &.focused {
    border-color: ${theme.colors.black};
  }

  svg {
    position: absolute;
    top: 50%;
    right: 24px;
    transform: translateY(-50%);
    cursor: pointer;
  }

  @media (min-width: 768px) {
    margin: 0 auto;
    width: 30%;
  }
`

export const Input = styled.input`
  width: 100%;
  padding: 20px 24px;
  border-radius: ${theme.border.mediumRadius};
  border: none;

  &::placeholder {
    color: ${theme.colors.gray500};
  }
`
